<template>
  <lu-vbox lu-flex class='tab-container' style='height: 100%'>
    <Spinner ref='spinner' style='z-index:60000 !important'/>

    <el-form label-position="right"  style='flex: 1 1 auto; display: flex;' ref="form" :model='form' lu-flex label-width="110px">
    <el-tabs class='bookTabs' v-model="activeName" tab-position="left"  type="border-card" style="margin: 20px;">
      <el-tab-pane v-for='(env, idx) in brokerListSelect' :key='idx' :label="env.label" :name="env.label" style='padding: 10px; display: flex; flex: 1 1 auto;'>
      <lu-vbox lu-flex>

          <template v-if="bookConfigMode">
            <el-tabs class='subTabs' v-model='activeTab' tab-position='top' type='border-card'>
              <el-tab-pane :lazy="true" :label='$t("Books")' name='books' id='elTree'>

                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>

                <lu-vbox class='config-container pad-in-5' v-if='newBook'>
                  <lu-hbox lu-vcenter class='title pad-in-5 '>
                    <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                    <lu-item >{{ $t('New book') }}</lu-item>
                  </lu-hbox>

                  <lu-hbox lu-flex lu-flex-wrap>
                    <lu-item>
                      <el-form-item style='width: 400px;' label="Book name" prop="bookName" required :rules='ruleBookName'  label-width="150px">
                        <el-input class='inputauto' v-model='form.bookName' />
                      </el-form-item>
                    </lu-item>
                    <!-- <lu-item>
                      <el-form-item style='width: 400px;' label="Book percentage" prop="percentValue" required :rules='rulePercent' label-width="150px">
                        <el-input class='inputauto' v-model='form.percentValue' />
                      </el-form-item>
                    </lu-item> -->
                  </lu-hbox>

                  <lu-hbox lu-hcenter class='pad-in-5'>
                    <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='createBook'>{{ $t('action.add') }}</el-button></lu-item>
                    <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelCreateBook'>{{ $t('action.cancel') }}</el-button></lu-item>
                  </lu-hbox>

                </lu-vbox>

                <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                  <lu-vbox lu-flex>

                    <lu-hbox lu-hright class='pad-in-5' >
                      <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('save') }}</el-button></lu-item>
                      <!-- <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('cancel') }}</el-button></lu-item> -->
                      <lu-item><el-button class="button" icon="el-icon-plus"   @click.stop='newBook = true'>{{ $t('New Book') }}</el-button></lu-item>
                      <lu-item><el-button :loading="downloadLoading" icon="el-icon-download" @click="handleDownload">{{ $t('Export Excel') }}</el-button></lu-item>
                    </lu-hbox>

                    <lu-vbox lu-flex style='margin-top:20px;' class='vpad-in-5'>
                      <lu-hbox lu-vcenter class='title pad-in-5 pageTitleLabel'>
                        <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                        <lu-item >{{ $t('Book definition') }}</lu-item>
                      </lu-hbox>

                      <lu-vbox lu-vcenter v-for='(item,idx) in form.bookList' :key='idx' style="width: 100%;">
                        <lu-hbox lu-vcenter lu-flex-wrap>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px' auto :label="$t('Name')" :prop='"bookList["+idx+"].bookName"' required :rules='ruleBookName'>
                                <el-input class='inputauto' :placeholder="$t('Book name')" type="text" @input='onBookRename(item)' clearable v-model='item.bookName' />
                            </el-form-item>
                          </lu-item>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; margin-left: 20px' auto :label="$t('Acc Platform')" :prop='"bookList["+idx+"].bookAccountNumber"' required :rules='ruleAccPlatform'>
                                <el-input class='inputauto' :placeholder="$t('Acc Platform')" type="text" @input='onAccPlatformRename(item)' clearable v-model='item.bookAccountNumber' />
                            </el-form-item>
                          </lu-item>

                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; margin-left: 20px; width: 120px;' auto label="%" :prop='"bookList["+idx+"].percentValue"' required :rules='rulePercent' label-width="40px" >
                                <el-input class='inputauto' type="number" :min="0" :max="100" v-model='item.percentValue' />
                            </el-form-item>
                          </lu-item>

                          <lu-item style='width: 200px;'>
                            <el-form-item style='margin-bottom: 0px; margin-left: 20px;' :label="$t('BookSet')" :prop='"bookList["+idx+"].bookSet"' required :rules='ruleBookSet'>
                              <el-select :placeholder="$t('BookSet')" v-model="item.bookSet" filterable>
                                <el-option
                                  v-for="bs in singleBookSetList"
                                  :key="bs.bookSet"
                                  :label="bs.bookName"
                                  :value="bs.bookSet">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </lu-item>

                          <lu-item style='width: 250px;'>
                            <el-form-item style='margin-bottom: 0px; margin-left: 20px;' :label="$t('Asset')" :prop='"bookList["+idx+"].assetId"' required :rules='ruleBookAsset'>
                              <el-select :placeholder="$t('Asset')" v-model="item.assetId" filterable>
                                <el-option
                                  v-for="ba in bookAssetList"
                                  :key="ba.assetId"
                                  :label="ba.asset"
                                  :value="ba.assetId">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </lu-item>

                          <lu-item style='width: 200px;'>
                            <el-form-item style='margin-bottom: 0px; margin-left: 20px;' :label="$t('Entity')" :prop='"bookList["+idx+"].entityId"' required :rules='ruleBookEntity'>
                              <el-select :placeholder="$t('Entity')" v-model="item.entityId" filterable>
                                <el-option
                                  v-for="entity in entityList"
                                  :key="entity.entityId"
                                  :label="entity.entity"
                                  :value="entity.entityId">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </lu-item>

                          <lu-item lu-click style='smargin-top:5px;font-size:1.5em; margin-left: 20px' @click.stop='onShowParameters(item)'>
                            <template v-if="item.showParameters">
                              <FontIcon type='material-icons' name='arrow_drop_up' class='icon' size='xsmall' />
                            </template>
                            <template v-else>
                              <FontIcon type='material-icons' name='arrow_drop_down' class='icon' size='xsmall' />
                            </template>
                          </lu-item>

                          <lu-item style='margin-left: 20px'>
                            <!-- <el-tooltip :effect='styleTooltip' :content='$t("Remove book")' placement='top' v-if='!isDefault(item)'> -->
                            <el-tooltip :effect='styleTooltip' :content='$t("Remove book")' placement='top'>
                              <lu-item lu-click class="el-icon-close" style='color: red;' @click='delBook(item)'></lu-item>
                            </el-tooltip>
                          </lu-item>
                        </lu-hbox>

                        <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                          <el-table
                            class='table'
                            :data="item.parameterList"
                            fit
                            striped
                            style="width: 100%; margin-top:10px;"
                            :default-sort = "{prop: 'id', order: 'ascending'}"
                            :row-class-name="tableRowClassName"
                            :show-header="false"
                            v-if='item.showParameters' 
                          >
                              <!-- <el-table-column :label="$t('Id')" prop='id' align="left" >
                                <template slot-scope="scope">
                                  <span>{{ scope.row.id }}</span>
                                </template>
                              </el-table-column> -->

                              <el-table-column :label="$t('Target')" prop='brokerPtfName' align="left" min-width="50">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.brokerPtfName }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column :label="$t('Type')" prop='paramName' align="left" min-width="50">
                                <template slot-scope="scope">
                                  <span>{{ scope.row.paramName }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column align="center" :label="$t('Parameter')" prop="paramValue" min-width="150">
                                <template slot-scope="scope">
                                  <el-input size="small" v-model="scope.row.paramValue" autosize type="textarea"></el-input>
                                </template>
                              </el-table-column>
                          </el-table>
                        <!-- </lu-scroll-area> -->

                      </lu-vbox>
                    </lu-vbox>

                  </lu-vbox>
                </lu-scroll-area>
              </el-tab-pane>
              <el-tab-pane :lazy="true" :label='$t("STP")' name='stp'>
                <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                  <el-form label-position="right" style='flex: 1 1 auto; display: flex;' ref="stpForm" :model='stpForm' lu-flex label-width="110px">

                    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
                      <lu-vbox class='config-container pad-in-5' v-if='newLP'>
                        <lu-hbox lu-vcenter class='title pad-in-5 '>
                          <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                          <lu-item >{{ $t('New LP') }}</lu-item>
                        </lu-hbox>

                        <lu-hbox lu-flex lu-flex-wrap>
                          <lu-item>
                            <el-form-item style='width: 400px;' label="Name" prop="lpName" required :rules='ruleLPName'  label-width="150px">
                              <el-input class='inputauto' v-model='stpForm.lpName' />
                            </el-form-item>
                          </lu-item>
                        </lu-hbox>

                        <lu-hbox lu-hcenter class='pad-in-5'>
                          <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='createLP(idx)'>{{ $t('action.add') }}</el-button></lu-item>
                          <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelCreateLP'>{{ $t('action.cancel') }}</el-button></lu-item>
                        </lu-hbox>

                      </lu-vbox>

                      <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                      <lu-vbox>

                        <lu-hbox lu-hright class='pad-in-5' >
                          <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='saveSTP(idx)'>{{ $t('save') }}</el-button></lu-item>
                          <!-- <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('cancel') }}</el-button></lu-item> -->
                          <lu-item><el-button class="button" icon="el-icon-plus"   @click.stop='newLP = true'>{{ $t('New LP') }}</el-button></lu-item>
                          <lu-item><el-button :loading="downloadLoading" icon="el-icon-download" @click="handleDownload">{{ $t('Export Excel') }}</el-button></lu-item>
                        </lu-hbox>

                        <lu-vbox lu-flex style='margin-top:20px;' class='vpad-in-5'>
                          <lu-hbox lu-vcenter class='title pad-in-5 pageTitleLabel'>
                            <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                            <lu-item >{{ $t('Counterparty Account') }}</lu-item>
                          </lu-hbox>

                          <lu-vbox lu-vcenter v-for='(item,idx) in stpForm.accountsList' :key='idx' style="width: 100%;">
                            <lu-hbox lu-vcenter>
                              <lu-item>
                                <el-form-item style='margin-bottom: 0px' auto :label="$t('Name')" :prop='"accountsList["+idx+"].accountName"' required :rules='ruleLPName'>
                                    <el-input class='inputauto' :placeholder="$t('Name')" type="text" clearable v-model='item.accountName' />
                                </el-form-item>
                              </lu-item>
                              <lu-item>
                                <el-form-item style='margin-bottom: 0px; margin-left: 20px' auto :label="$t('Acc')" :prop='"accountsList["+idx+"].accountNumber"' required :rules='ruleLPAcc'>
                                    <el-input class='inputauto' :placeholder="$t('Acc')" type="text" clearable v-model='item.accountNumber' />
                                </el-form-item>
                              </lu-item>
                              <lu-item style='margin-left: 30px'>
                                <!-- <el-tooltip :effect='styleTooltip' :content='$t("Remove book")' placement='top' v-if='!isDefault(item)'> -->
                                <el-tooltip :effect='styleTooltip' :content='$t("Remove LP")' placement='top'>
                                  <lu-item lu-click class="el-icon-close" style='color: red;' @click='delLP(item)'></lu-item>
                                </el-tooltip>
                              </lu-item>
                            </lu-hbox>

                          </lu-vbox>
                        </lu-vbox>

                        <lu-vbox lu-flex style='margin-top:20px;' class='vpad-in-5'>
                          <lu-hbox id='elTransfer' lu-vcenter class='title pad-in-5 '>
                            <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                            <lu-item >{{ $t('STP Clients') }}</lu-item>
                          </lu-hbox>

                          <lu-item>
                            <el-form-item style='width:800px;min-height: 40px;' label="Group list" prop="groupName" label-width="150px">
                              <el-input autosize type="textarea" v-model='stpForm.groupName' style='min-height: 80px;'/>
                            </el-form-item>
                          </lu-item>

                          <lu-item>
                            <el-form-item style='width:800px;min-height: 40px;' label="Account list" prop="accountName" label-width="150px">
                              <el-input autosize type="textarea" v-model='stpForm.accountName' style='min-height: 80px;'/>
                            </el-form-item>
                          </lu-item>
                        </lu-vbox>

                      </lu-vbox>
                    </lu-scroll-area>
                  </el-form>
                <!-- </lu-scroll-area> -->
              </el-tab-pane>
            </el-tabs>
          </template>

          <template v-else>
            <el-tabs class='subTabs' v-model='activeTab' tab-position='top' type='border-card'>
              <el-tab-pane :lazy="true" :label='$t("Books")' name='books' id='elTree'>
                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>

                <lu-vbox class='config-container pad-in-5' v-if='newBook'>
                  <lu-hbox lu-vcenter class='title pad-in-5 '>
                    <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                    <lu-item >{{ $t('New book') }}</lu-item>
                  </lu-hbox>

                  <lu-hbox lu-flex lu-flex-wrap>
                    <lu-item>
                      <el-form-item style='width: 400px;' label="Book name" prop="bookName" required :rules='ruleBookName'  label-width="150px">
                        <el-input class='inputauto' v-model='form.bookName' />
                      </el-form-item>
                    </lu-item>
                    <lu-item>
                      <el-form-item style='width: 400px;' label="Book percentage" prop="percentValue" required :rules='rulePercent' label-width="150px">
                        <el-input class='inputauto' v-model='form.percentValue' />
                      </el-form-item>
                    </lu-item>
                    <lu-item>
                      <el-form-item style='width:800px;min-height: 40px;' label="Group list" prop="groupList" label-width="150px">
                        <el-input autosize type="textarea" v-model='form.groupList' style='min-height: 80px;'/>
                      </el-form-item>
                    </lu-item>
                  </lu-hbox>

                  <lu-hbox lu-hcenter class='pad-in-5'>
                    <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='createBook'>{{ $t('action.add') }}</el-button></lu-item>
                    <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancelCreateBook'>{{ $t('action.cancel') }}</el-button></lu-item>
                  </lu-hbox>

                </lu-vbox>

                <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                  <lu-vbox lu-flex>

                    <lu-hbox lu-hright class='pad-in-5' >
                      <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='save'>{{ $t('save') }}</el-button></lu-item>
                      <!-- <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='cancel'>{{ $t('cancel') }}</el-button></lu-item> -->
                      <lu-item><el-button class="button" icon="el-icon-plus"   @click.stop='newBook = true'>{{ $t('New Book') }}</el-button></lu-item>
                    </lu-hbox>

                    <lu-vbox class=' vpad-in-5'>
                      <lu-hbox lu-vcenter class='title pad-in-5'>
                          <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                          <lu-item >{{ $t('Default book') }}</lu-item>
                      </lu-hbox>

                      <lu-hbox lu-vcenter v-for='(item,idx) in form.defaultList' :key='idx'>
                        <lu-item>
                          <el-form-item style='margin-bottom: 0px;' auto :label="$t('Name')" :prop='"defaultList["+idx+"].bookName"' :rules='ruleBookName' required>
                              <el-input class='inputauto' disabled readonly :placeholder="$t('Book name')" type="text" clearable v-model='item.bookName'/>
                          </el-form-item>
                        </lu-item>
                        <lu-item>
                          <el-form-item style='margin-bottom: 0px; width: 200px;' auto :label="$t('Percentage')" :prop='"defaultList["+idx+"].percentValue"' required :rules='rulePercent'>
                            <el-input class='inputauto' :placeholder="$t('Percentage')" type="text" clearable v-model='item.percentValue' >
                                <!-- <span slot="append">%</span> -->
                            </el-input>
                          </el-form-item>
                        </lu-item>
                        <!--
                        <lu-item style='margin-left: 10px'>
                          <el-tooltip :effect='styleTooltip' :content='$t("Remove book")' placement='top'>
                            <lu-item lu-click class="el-icon-close" style='color: red;' @click='delDefault(item)'></lu-item>
                          </el-tooltip>
                        </lu-item>
                        -->
                      </lu-hbox>
                    </lu-vbox>

                    <lu-vbox lu-flex style='margin-top:20px;' class='vpad-in-5'>
                      <lu-hbox lu-vcenter class='title pad-in-5 pageTitleLabel'>
                        <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                        <lu-item >{{ $t('Book definition') }}</lu-item>
                      </lu-hbox>

                      <lu-vbox lu-vcenter v-for='(item,idx) in form.bookList' :key='idx' style="width: 100%;">
                        <lu-hbox lu-vcenter>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px' auto :label="$t('Name')" :prop='"bookList["+idx+"].bookName"' required :rules='ruleBookName'>
                                <el-input class='inputauto' :placeholder="$t('Book name')" type="text" @input='onBookRename(item)' clearable v-model='item.bookName' />
                            </el-form-item>
                          </lu-item>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; width: 200px;' auto :label="$t('Percentage')" :prop='"bookList["+idx+"].percentValue"' required :rules='rulePercent'>
                                <el-input class='inputauto' :placeholder="$t('Percentage')" type="text" clearable v-model='item.percentValue' />
                            </el-form-item>
                          </lu-item>

                          <lu-item lu-click style='smargin-top:5px;font-size:1.5em;' @click.stop='onShowInstruments(item)'>
                            <template v-if="item.showInstruments">
                              <FontIcon type='material-icons' name='arrow_drop_up' class='icon' size='xsmall' />
                            </template>
                            <template v-else>
                              <FontIcon type='material-icons' name='arrow_drop_down' class='icon' size='xsmall' />
                            </template>
                          </lu-item>

                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; width: 500px; min-height: 40px;' auto :label="$t('Group list')" :prop='"bookList["+idx+"].groupList"' >
                                <el-input autosize type='textarea' style='min-height: 40px;' :placeholder="$t('Group list')" clearable v-model='item.groupList' />
                            </el-form-item>
                          </lu-item>
                          <lu-item style='margin-left: 10px'>
                            <template v-if='isDefault(item)'>
                              <!--
                              <el-tooltip :effect='styleTooltip' :content='$t("Unset as default")' placement='top'>
                                <lu-item class="el-icon-star-on" style='color: yellow;' @click='unsetDefault(item)'></lu-item>
                              </el-tooltip>
                              -->
                              <lu-item class="el-icon-star-on" style='color: yellow;'></lu-item>
                            </template>
                            <template v-else>
                              <el-tooltip :effect='styleTooltip' :content='$t("Set as default")' placement='top'>
                                <lu-item lu-click class="el-icon-star-off" style='color: grey;' @click='setDefault(item)'></lu-item>
                              </el-tooltip>
                            </template>
                          </lu-item>
                          <lu-item style='margin-left: 10px'>
                            <el-tooltip :effect='styleTooltip' :content='$t("Remove book")' placement='top' v-if='!isDefault(item)'>
                              <lu-item lu-click class="el-icon-close" style='color: red;' @click='delBook(item)'></lu-item>
                            </el-tooltip>
                          </lu-item>
                        </lu-hbox>


                        <lu-hbox lu-hcenter class='config-container pad-in-5' v-if='item.showInstruments'  style='margin-top:10px;'>
                          <lu-item>
                            <el-form-item style='width: 400px;' label="Instrument" :prop='"bookList["+idx+"].addInstrumentName"' :rules='ruleAddInstrumentName'  label-width="150px">
                              <el-select placeholder="Instrument" v-model="item.addInstrumentName" clearable filterable>
                                <el-option
                                  v-for="ins in currentInstrumentList"
                                  :key="ins.instrumentName"
                                  :label="ins.instrumentName"
                                  :value="ins.instrumentName">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </lu-item>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; width: 200px;' auto :label="$t('Percentage')" :prop='"bookList["+idx+"].addPercentValue"' :rules='ruleAddPercent'>
                                <el-input class='inputauto' :placeholder="$t('Percentage')" type="text" clearable v-model='item.addPercentValue' />
                            </el-form-item>
                          </lu-item>
                          <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='addBookInstrument(item)'>{{ $t('action.add') }}</el-button></lu-item>
                        </lu-hbox>

                        <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                          <el-table
                            class='table'
                            :data="item.instrumentList"
                            fit
                            striped
                            style="width: 100%; margin-top:10px;"
                            :default-sort = "{prop: 'instrumentName', order: 'ascending'}"
                            :row-class-name="tableRowClassName"
                            v-if='item.showInstruments' 
                          >
                              <el-table-column :label="$t('Instrument')" sortable prop='instrumentName' align="left" >
                                <template slot-scope="scope">
                                  <span>{{ scope.row.instrumentName }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column align="center" :label="$t('Percentage')"     sortable prop="percentValue" width="200">
                                <template slot-scope="scope">
                                  <el-input-number size="small" v-model="scope.row.percentValue" type="number" :min="0" :max="100"></el-input-number>
                                </template>
                              </el-table-column>

                            <el-table-column :label="$t('Actions')" align="center" width="150">
                              <template slot-scope="scope">
                                <lu-hbox lsu-hcenter slu-vcenter cslass='pad-in-5'>
                                  <el-button class="icon" size="mini" icon='el-icon-close' @click.stop='deleteBookInstrument(item,scope.row)' />
                                </lu-hbox>
                              </template>
                            </el-table-column>
                          </el-table>
                        <!-- </lu-scroll-area> -->


                        <!-- <lu-hbox lu-vcenter v-for='(itemIns,idxIns) in item.instrumentList' :key='idxIns'>
                          <lu-item>
                            <el-form-item style='margin-bottom: 0px; width: 200px;' auto :label="$t('Instrument')" :prop='"bookList["+idx+"].percentValue"' required :rules='rulePercent'>
                                <el-input :placeholder="$t('Percentage')" type="text" clearable v-model='item.percentValue' />
                            </el-form-item>
                            <span>{{ itemIns.instrumentName }}</span>
                          </lu-item>
                          <lu-item>
                            <span>{{ itemIns.percentValue }}</span>
                          </lu-item>
                        </lu-hbox> -->
                      </lu-vbox>
                    </lu-vbox>

                    <lu-vbox lu-flex style='margin-top:20px; min-height: 300px; ' class='vpad-in-5'>
                      <lu-hbox id='elTransfer' lu-vcenter class='title pad-in-5 '>
                        <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                        <lu-item >{{ $t('Counterparty Accounts') }}</lu-item>
                      </lu-hbox>
                          <el-transfer
                            style='padding-left: 110px; max-height: 400px;'
                            v-model="form.coverageList"
                            filterable
                            :filter-placeholder="$t('Group name')"
                            :titles="[$t('List'), $t('Selected')]"
                            :format="{
                              noChecked: '${total}',
                              hasChecked: '${checked}/${total}'
                            }"
                            :props="{
                              key: 'groupName',
                              label: 'groupName'
                            }"
                            :data="groupSearchList"
                            >
                          </el-transfer>

                    </lu-vbox>
                  </lu-vbox>
                </lu-scroll-area> 
              </el-tab-pane>
              <el-tab-pane :lazy="true" :label='$t("Transfer")' name='transfer' style='padding: 10px; display: flex; flex: 1 1 auto;'>
                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
                  <el-form label-position="right" style='flex: 1 1 auto; display: flex;' ref="transferForm" :model='transferForm' lu-flex label-width="110px">
                    <lu-vbox lu-flex>
                      <lu-hbox lu-hright class='pad-in-5' >
                        <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='validateTransfer(idx)'>{{ $t('validate') }}</el-button></lu-item>
                        <!-- <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='getCurrentAccountPosition()'>{{ $t('refresh') }}</el-button></lu-item> -->
                      </lu-hbox>
                      <lu-vbox style='margin-top:20px;' class='vpad-in-5'>
                        <lu-item style='width: 350px; margin-left: auto; margin-right: auto;'>
                          <el-form-item label="Account">
                            <el-select placeholder="Account" v-model="transferAccountFilter" clearable filterable remote :remote-method="transferAccountRemoteMethod" @visible-change="onVisibleChangeTransferAccountFilter" :loading="transferAccountLoading" style='width: 350px'>
                              <el-option
                                v-for="acc in transferAccountList"
                                :key="acc.dosId"
                                :label="acc.dosName +' - ' + acc.dosId"
                                :value="acc.dosId">
                                <div style="float: left">{{ acc.dosName }}</div>
                                <div style="margin-left: 10px;float: right; color: #8492a6; font-size: 13px">{{ acc.dosId }}</div>
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </lu-item>
                      <lu-vbox lu-flex>
                          <lu-vbox class='vpad-in-5'>
                            <lu-hbox lu-vcenter class='title pad-in-5'>
                                <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                                <lu-item >{{ $t('Transfer from') }}</lu-item>
                            </lu-hbox>
                            <lu-hbox lu-vcenter class='title pad-in-5'>
                              <lu-item style='margin-bottom: 0px; width: 400px;'>
                                <el-form-item auto :label="$t('Book')">
                                  <el-input class='inputauto' :placeholder="$t('Book')" type="text" readonly disabled v-model='transferForm.bookName' />
                                  <!-- <span>{{ transferCurrentBookName }}</span> -->
                                </el-form-item>
                              </lu-item>
                              <lu-item style='margin-bottom: 0px; width: 200px;'>
                                <el-form-item auto :label="$t('Percentage')">
                                  <el-input class='inputauto' :placeholder="$t('Percentage')" type="text" readonly disabled v-model='transferForm.percentValue' />
                                  <!-- <span>{{ transferCurrentPercentage }}</span> -->
                                </el-form-item>
                              </lu-item>
                            </lu-hbox>
                          </lu-vbox>

                          <lu-vbox class='vpad-in-5'>
                            <lu-hbox lu-vcenter class='title pad-in-5'>
                                <FontIcon type='material-icons' name='keyboard_arrow_right' class='icon' size='xsmall' />
                                <lu-item >{{ $t('Transfer to') }}</lu-item>
                            </lu-hbox>
                            <lu-hbox lu-vcenter class='title pad-in-5'>
                              <lu-item style='margin-bottom: 0px; width: 400px;'>
                                <el-form-item label="Book" prop="newBookId" :rules='ruleTransferNewBook' ref="newBookIdFormItem">
                                  <el-select placeholder="Book" v-model="transferForm.newBookId" clearable filterable >
                                    <el-option
                                      v-for="book in bookList"
                                      :key="book.bookId"
                                      :label="book.bookName"
                                      :value="book.bookId">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </lu-item>
                              <lu-item style='margin-bottom: 0px; width: 200px;'>
                                <el-form-item auto :label="$t('Percentage')" prop="newPercentValue" required :rules='ruleTransferPercent'>
                                    <el-input class='inputauto' :placeholder="$t('Percentage')" type="text" clearable v-model='transferForm.newPercentValue' />
                                </el-form-item>
                              </lu-item>
                            </lu-hbox>
                          </lu-vbox>

                          <!-- <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'> -->
                          <el-table
                            class='table'
                            :data="transferForm.instrumentList"
                            fit
                            striped
                            style="width: 100%; margin-top:10px;"
                            :default-sort = "{prop: 'instrumentName', order: 'ascending'}"
                            :row-class-name="tableRowClassName"
                          >
                              <el-table-column :label="$t('Instrument')" sortable prop='instrumentName' align="left" >
                                <template slot-scope="scope">
                                  <span>{{ scope.row.instrumentName }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column :label="$t('Side')" sortable prop='orderSide' align="center" >
                                <template slot-scope="scope">
                                  <span>{{ getSideLabel(scope.row.orderSide) }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column :label="$t('Exposure')" sortable prop='exposure' :sort-method=sortExposure align="center" >
                                <template slot-scope="scope">
                                  <span>{{ scope.row.exposure | formatAmount }}</span>
                                </template>
                              </el-table-column>

                              <el-table-column align="center" :label="$t('Price')" sortable prop="rate" width="200">
                                <template slot-scope="scope">
                                  <el-input-number size="small" v-model="scope.row.rate" type="number" @change="changeTransferInstrumentRate(scope.row)" :min="getPrecisionStep(scope.row.decimals)" :controls="true" :step="getPrecisionStep(scope.row.decimals)"  :precision="scope.row.decimals"></el-input-number>
                                </template>
                              </el-table-column>
                          </el-table>
                          <!-- </lu-scroll-area> -->

                        </lu-vbox>
                      </lu-vbox>
                    </lu-vbox>
                  </el-form>
                </lu-scroll-area>
              </el-tab-pane>
              <el-tab-pane :lazy="true" :label='$t("Transfer History")' name='transferHistory' style='padding: 10px; display: flex; flex: 1 1 auto;'>
                
                <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
                  <lu-vbox lu-flex>
                    <el-table
                      class='historyTable'
                      :data="bookTransferList"
                      fit
                      striped
                      resizable
                      style="width: 100%; margin-top:10px;"
                      :default-sort = "{prop: 'creationDateTime', order: 'descending'}"
                      :row-class-name="tableRowClassName"
                    >
                        <el-table-column :label="$t('Env')" sortable prop='brokerName' align="left" >
                          <template slot-scope="scope">
                            <span>{{ scope.row.brokerName }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column :label="$t('Client')" sortable prop='dosName' align="left" >
                          <template slot-scope="scope">
                            <span>{{ scope.row.dosName }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column :label="$t('Account')" sortable prop='dosId' align="left" >
                          <template slot-scope="scope">
                            <span>{{ scope.row.dosId }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column :label="$t('Date/Time')" sortable prop='creationDateTime' align="left" >
                          <template slot-scope="scope">
                            <span>{{ scope.row.creationDateTime }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column label="From">
                          <el-table-column :label="$t('Book')" sortable prop='fromBookName' align="left" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.fromBookName }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('Percentage')" sortable prop='fromPercentValue' align="center" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.fromPercentValue }}</span>
                            </template>
                          </el-table-column>
                        </el-table-column>

                        <el-table-column label="To">
                          <el-table-column :label="$t('Book')" sortable prop='toBookName' align="left" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.toBookName }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('Percentage')" sortable prop='toPercentValue' align="center" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.toPercentValue }}</span>
                            </template>
                          </el-table-column>
                        </el-table-column>

                        <!-- <el-table-column :label="$t('From')" align="center">
                          <el-table-column :label="$t('Book')" sortable prop='bookList[0].bookName' align="left" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.bookList[0].bookName }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('Percentage')" sortable prop='bookList[0].percentValue' align="center" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.bookList[0].percentValue }}</span>
                            </template>
                          </el-table-column>
                        </el-table-column> -->
                        <!-- <el-table-column label="To" align="center">
                          <el-table-column :label="$t('Book')" sortable prop='bookList[1].bookName' align="left" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.bookList[1].bookName }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('Percentage')" sortable prop='bookList[1].percentValue' align="center" >
                            <template slot-scope="scope">
                              <span>{{ scope.row.bookList[1].percentValue }}</span>
                            </template>
                          </el-table-column>
                        </el-table-column> -->
                    </el-table>
                  </lu-vbox>
                </lu-scroll-area>
              </el-tab-pane>
            </el-tabs>
          </template>
        </lu-vbox>
      </el-tab-pane>
    </el-tabs>
    </el-form>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuItem, LuVbox, LuScrollArea } from 'lusis-ui'
import { mapGetters, mapState } from 'vuex'
import Spinner from '@/components/Spinner'
import FontIcon from '@/components/FontIcon'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'

export default {
  name: 'BookConfig',
  props: [ 'defaultTab' ],
  components: { Spinner, FontIcon, LuHbox, LuItem, LuVbox, LuScrollArea },
  data () {
    return {
      activeName: null,
      newBook: false,
      newLP: false,
      // localBrokerList: [],
      forceLoading: false,
      forceLoadingSTP: false,
      defaultList: [],
      bookList:[],
      coverageList: [],
      // activeTab: 'books',
      activeTab: this.defaultTab ? this.defaultTab : 'books',
      transferAccountFilter: null,
      transferData: {},
      shouldUpdateTransferHistory: true,
      bookTransferList: [],
      transferAccountLoading: false,
      transferAccountQuery: "",
      transferAccountLimit: 100,
      transferAccountList: [],
      downloadLoading: false,
      form: {
        bookName: null,
        percentValue: 100,
        groupList: null,
        searchGroupName: null,
        defaultList: [],
        bookList:[],
        coverageList: [],
        bookSet: 0,
        assetId: 0,
        entityId: 0
      },
      ruleBookName: [
        { validator: this.validateBook },
        { required: true, message: 'Please input book name', trigger: ['blur', 'change'] }
      ],
      ruleAccPlatform: [
        { validator: this.validateAccPlatform },
        { required: true, message: 'Please input acc platform', trigger: ['blur', 'change'] }
      ],
      rulePercent: [
        { validator: this.validatePercent },
        { required: true, message: 'Please input percent value', trigger: ['blur', 'change'] }
      ],
      ruleGroupList:[
        { required: true, message: 'Please input group list value', trigger: ['blur', 'change'] }
      ],
      ruleAddInstrumentName:[
        { required: true, message: 'Please input instrument value', trigger: ['blur', 'change'] }
      ],
      ruleAddPercent: [
        { validator: this.validatePercent },
        { required: true, message: 'Please input percent value', trigger: ['blur', 'change'] }
      ],
      ruleTransferNewBook:[
        { required: true, message: 'Please input book value', trigger: ['blur', 'change'] }
      ],
      ruleTransferPercent: [
        { validator: this.validateTransferPercent },
        { required: true, message: 'Please input percent value', trigger: ['blur', 'change'] }
      ],
      ruleLPName: [
        { validator: this.validateLPName },
        { required: true, message: 'Please input name', trigger: ['blur', 'change'] }
      ],
      ruleLPAcc: [
        { validator: this.validateLPAcc },
        { required: true, message: 'Please input acc', trigger: ['blur', 'change'] }
      ],
      ruleBookSet: [
        { required: true, message: 'Please input bookset', trigger: ['blur', 'change'] }
      ],
      ruleBookAsset: [
        { required: true, message: 'Please input asset', trigger: ['blur', 'change'] }
      ],
      ruleBookEntity: [
        { required: true, message: 'Please input entity', trigger: ['blur', 'change'] }
      ],
      transferForm: {
        brokerName: null,
        bookId: null,
        bookName: null,
        percentValue: 100,
        dosId: null,
        dosName: null,
        instrumentList: [],
        newBookId: null,
        newPercentValue: 100
      },
      stpForm: {
        lpName: null,
        accountsList: [],
        groupName: null,
        accountName: null
      },
      stpData: {
        accountsList: [],
        groupName: '',
        accountName: ''
      }
    }
  },
  created () {
    this.activeName = (this.brokerListSelect && this.brokerListSelect.length) ? this.brokerListSelect[0].label : null
  },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value || 0, 2, 3)
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    },
    formatPercent: function (value) {
      return (value || 0) + ' %'
    }
  },
  watch: {
    activeName () {
      //book
      this.newBook = false
      this.form.bookName = null
      this.form.percentValue = 100
      this.form.groupList = null
      this.form.bookSet = 0
      this.form.assetId = 0
      this.form.entityId = 0

      // stp
      this.newLP = false
      this.stpForm.lpName = null
      // this.stpForm.accountsList = []

      //transfer
      this.transferForm.brokerName = null
      this.transferForm.bookId = null
      this.transferForm.bookName = null
      this.transferForm.percentValue = 100
      this.transferForm.dosId = null
      this.transferForm.dosName = null
      this.transferForm.instrumentList = []
      this.transferForm.newBookId = null
      this.transferForm.newPercentValue = 100
      this.resetTransferFormFields()
      this.transferAccountFilter = null
      this.bookTransferList = []
      this.shouldUpdateTransferHistory = true

      this.transferAccountRemoteMethod()
    }
  },
  methods: {
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else {
        return 'even-row';
      }
    },
    sortExposure: function(a,b){
      let numA = 0
      if (a!==null && a!==undefined && a.hasOwnProperty('exposure'))
        numA = parseFloat(a.exposure)
      let numB = 0
      if (b!==null && a!==undefined && a.hasOwnProperty('exposure'))
        numB = parseFloat(b.exposure)
      if (numA>numB)
        return 1
      else if (numA<numB)
        return  -1
      return 0
    },
    makeDiff (server, client, comp, diff) {
      let arr = []
      if (server && client) {
        server.forEach(b => {
          let idx = client.findIndex(c => comp(b, c))
          if (idx === -1) {
            //delete
            arr.push(Object.assign({
              action: 3
            }, b))
          }
        })
      }
      if (client && server) {
        client.forEach(b => {
          let idx = server.findIndex(s => comp(s, b))
          if (idx === -1) {
            //insert
            arr.push(Object.assign({
              action: 1
            }, b))
          }
          else if (diff) {
            if (diff(server[idx], b)) {
              //update
              arr.push(Object.assign({
                action: 2
              }, b))
            }
          }
        })
      }
      return arr
    },
    makeDiffInstrumentList (server, client, comp, diff,comp2,diff2) {
      // comp, diff, arr => book
      // comp2, diff2, arr2 => instrument
      // action : 1 (insert), 2 (update), 3 (delete)

      let arr = []
      let arr2 = []
      if (server && client) {
        server.forEach(b => {
          let idx = client.findIndex(s => comp(b, s))
          if (idx === -1) {
            //delete book
            arr.push(Object.assign({
              action: 3
            }, this.getBookBus(b)))

            //delete instrument
            // if (b.instrumentList!==null && b.instrumentList!==undefined)
            //   b.instrumentList.forEach(b2 => {
            //     arr2.push(Object.assign({
            //       action: 3,
            //       bookId: b.bookId,
            //       bookName: b.bookName,
            //       bookAccountNumber: b.bookAccountNumber
            //     }, b2))
            //   })

          } else {
            //instrumentList
            if (b.instrumentList!==null && b.instrumentList!==undefined)
              b.instrumentList.forEach(b2 => {
                let idx2 = -1
                if (client[idx].instrumentList!==null && client[idx].instrumentList!==undefined)
                  idx2 = client[idx].instrumentList.findIndex(s2 => comp2(b2, s2))
                if (idx2 === -1) {
                  //delete instrument
                  arr2.push(Object.assign({
                    action: 3,
                    bookId: b.bookId,
                    bookName: b.bookName,
                    bookAccountNumber: b.bookAccountNumber,
                    percentValue: b.percentValue
                  }, b2))
                }
              })
          }
        })
      }
      if (client && server) {
        client.forEach(b => {
          let idx = server.findIndex(s => comp(s, b))
          if (idx === -1) {
            //insert book
            arr.push(Object.assign({
              action: 1
            }, this.getBookBus(b)))

            //insert instrument
            if (b.instrumentList!==null && b.instrumentList!==undefined)
              b.instrumentList.forEach(b2 => {
                arr2.push(Object.assign({
                  action: 1,
                  bookId: b.bookId,
                  bookName: b.bookName,
                  bookAccountNumber: b.bookAccountNumber,
                  percentValue: b.percentValue
                }, b2))
              })
          }
          else {
            if (diff) {
              if (diff(server[idx], b)) {
                //update book
                arr.push(Object.assign({
                  action: 2
                }, this.getBookBus(b)))
              }
            }

            //instrumentList
            if (b.instrumentList!==null && b.instrumentList!=undefined)
              b.instrumentList.forEach(b2 => {
                let idx2 = -1
                if (server[idx].instrumentList!==null && server[idx].instrumentList!==undefined)
                  idx2 = server[idx].instrumentList.findIndex(s2 => comp2(s2, b2))
                if (idx2 === -1) {
                  //insert instrument
                  arr2.push(Object.assign({
                    action: 1,
                    bookId: b.bookId,
                    bookName: b.bookName,
                    bookAccountNumber: b.bookAccountNumber,
                    percentValue: b.percentValue
                  }, b2))
                } else if(diff2) {
                    if (diff2(server[idx].instrumentList[idx2], b2)) {
                      //update instrument
                      arr2.push(Object.assign({
                        action: 2,
                        bookId: b.bookId,
                        bookName: b.bookName,
                        bookAccountNumber: b.bookAccountNumber,
                        percentValue: b.percentValue
                      }, b2))
                    }
                  }
              })
          }
        })
      }
      return [arr,arr2]
    },
    makeDiffTransferInstrument (server, client, comp, diff,keys) {
      let arr = []
      if (client && server) {
        client.forEach(b => {
          let idx = server.findIndex(s => comp(s, b))
          if (idx !== -1 && diff) {
            if (diff(server[idx], b)) {
              //update
              arr.push(keys.reduce((result, key) => ({ ...result, [key]: b[key] }), {}))
              //arr.push(b)
            }
          }
        })
      }
      return arr
    },
    getBookBus(b) {
      //clear tags: showInstruments,addInstrumentName,addPercentValue,instrumentList,showParameters
      // eslint-disable-next-line no-unused-vars
      return (({showInstruments,addInstrumentName,addPercentValue,instrumentList,showParameters, ...others}) => ({...others}))(b)
    },
    cancel () {
      this.form.defaultList = this.clone(this.defaultList)
      this.form.bookList = this.clone(this.bookList)
      this.form.coverageList = this.coverageList.map(item => item.groupName)
    },
    cancelTransfer () {
      this.transferForm.newBookId = this.transferData.newBookId
      this.transferForm.newPercentValue = this.transferData.newPercentValue
      this.transferForm.instrumentList = this.clone(this.transferData.instrumentList)
    },
    getBookSetLabel (bookSet) {
          let bs = this.bookSetList.find(b => b.bookSet === bookSet)
          if (bs) {
            return bs.bookName
          }
          return ""
    },
    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []

        let headers = [
          [ 'Book Name', 'Acc Platform','%','BookSet','Asset','Entity','','',''],
        ]
        // 'Book Name',
        // 'Acc Platform',
        // '%'
        // 'BookSet'
        // 'Asset'
        // 'Entity'
        // 'Target',
        // 'Type',
        // 'Parameters'

        // Book definition [1]
        let styles = []
        let styleIndex = headers.length
        let tableData = []

        styles.push({
          key: 1,
          type: 'row',
          // value: { bold: true }, //xlsx-populate
          propValue: { "font":{ bold: true } } //exceljs
        })

        this.bookList.forEach(book=> {
          tableData.push([book.bookName,book.bookAccountNumber,book.percentValue,this.getBookSetLabel(book.bookSet),book.asset,book.entity,'','',''])
          styles.push({
            key: ++styleIndex,
            type: 'row',
            // value: { bold: true, fill: "cccccc" }, //xlsx-populate
            propValue: { "font":{ bold: true }, "fill": {type: 'pattern', pattern: 'solid', fgColor: {argb: 'cccccc'}} } //exceljs
          })

          if (book.parameterList) {
            styleIndex+=book.parameterList.length
            book.parameterList.forEach(param => {
              tableData.push(['','','','','','',param.brokerPtfName,param.paramName,param.paramValue])
            })
          }
        })

        sheetList.push({
          multiHeader: headers,
          data: tableData,
          merges: [],
          sheetName: 'Books',
          styles: styles
        })

        // Counterparty Acccounts [2]
        let headers2 = [
          [ 'LP Name', 'Acc'],
        ]
        let tableData2 = []
        let styles2 = []
        if (this.stpData && this.stpData.accountsList && this.stpData.accountsList.length) {
          this.stpData.accountsList.forEach(acc => {
            tableData2.push([acc.accountName, acc.accountNumber])
          })
        }

        styles2.push({
          key: 1,
          type: 'row',
          // value: { bold: true }, //xlsx-populate
          propValue: { "font":{ bold: true } } //exceljs
        })

        sheetList.push({
          multiHeader: headers2,
          data: tableData2,
          merges: [],
          sheetName: 'Counterparty Acccounts',
          styles: styles2
        })

        // STP Clients [3]
        let tableData3 = []
        let styles3 = []

        styles3.push({
          key: 1,
          type: 'column',
          // value: { bold: true }, //xlsx-populate
          propValue: { "font":{ bold: true } } //exceljs
        })

        tableData3.push(["Group List", this.stpData.groupName])
        tableData3.push(["", ""])
        tableData3.push(["Account List", this.stpData.accountName])

        sheetList.push({
          multiHeader: [],
          data: tableData3,
          merges: [],
          sheetName: 'STP Clients',
          styles: styles3
        })

        let filename = 'BookConfig' + '-' + this.activeName + '_' +  timestamp()

        excel.export_json_to_excel_lusis_multisheet({
          filename: filename,
          autoWidth: true,
          bookType: 'xlsx',
          sheets: sheetList
        })

        this.downloadLoading = false
      })
    },
    // handleDownload() {
    //   this.downloadLoading = true
    //   import('@/vendor/Export2Excel').then(excel => {
    //     let sheetList = []

    //     let headers = [
    //       [ 'Book Name', 'Acc Platform','','',''],
    //     ]
    //     // 'Book Name',
    //     // 'Acc Platform',
    //     // 'Target',
    //     // 'Type',
    //     // 'Parameters'

    //     // Book definition
    //     let styles = []
    //     let styleIndex = headers.length
    //     let tableData = []
    //     this.bookList.forEach(book=> {
    //       tableData.push([book.bookName,book.bookAccountNumber,'','',''])
    //       styles.push({
    //         key: ++styleIndex,
    //         type: 'row',
    //         value: { bold: true, fill: "cccccc" }, //xlsx-populate
    //         propValue: { "font":{ bold: true }, "fill": {type: 'pattern', pattern: 'solid', fgColor: {argb: 'cccccc'}} } //exceljs
    //       })

    //       if (book.parameterList) {
    //         styleIndex+=book.parameterList.length
    //         book.parameterList.forEach(param => {
    //           tableData.push(['','',param.brokerPtfName,param.paramName,param.paramValue])
    //         })
    //       }
    //     })

    //     sheetList.push({
    //       multiHeader: headers,
    //       data: tableData,
    //       merges: [],
    //       sheetName: 'Book Definition',
    //       styles: styles
    //     })

    //     // Counterparty Acccounts
    //     let headers2 = [
    //       [ 'Group Name']
    //     ]
    //     let tableData2 = []
    //     if (this.coverageList) {
    //       this.coverageList.forEach(cp => {
    //         tableData2.push([cp.groupName])
    //       })
    //     }
    //     sheetList.push({
    //       multiHeader: headers2,
    //       data: tableData2,
    //       merges: [],
    //       sheetName: 'Counterparty Accounts',
    //       styles: []
    //     })

    //     let filename = 'BookConfig' + '-' + this.activeName + '_' +  timestamp()

    //     excel.export_json_to_excel_lusis_multisheet({
    //       filename: filename,
    //       autoWidth: true,
    //       bookType: 'xlsx',
    //       sheets: sheetList
    //     })

    //     this.downloadLoading = false
    //   })
    // },
    cancelSTP () {
      this.stpForm.accountsList = this.clone(this.stpData.accountsList)
      this.stpForm.groupName = this.stpData.groupName
      this.stpForm.accountName = this.stpData.accountName
    },
    saveSTP (idx) {
      this.$nextTick().then(() => {
        this.$refs.stpForm[idx].validate(valid => {
          if (valid) {
            let accountsList = this.makeDiff(this.stpData.accountsList, this.stpForm.accountsList, (account1, account2) => account1.id === account2.id, (account1, account2) => account1.accountName !== account2.accountName || account1.accountNumber !== account2.accountNumber)

            if (accountsList.length || this.stpForm.groupName!==this.stpData.groupName || this.stpForm.accountName!==this.stpData.accountName) {
              this.$refs.spinner.show()

              let cond = {
                parameterList: [
                  {
                    paramName: 'broker',
                    paramValue: this.activeName
                  }
                ],
                accountsList: accountsList,
              }

              if (this.stpForm.groupName!==this.stpData.groupName) {
                cond.groupName = this.stpForm.groupName
              }

              if (this.stpForm.accountName!==this.stpData.accountName) {
                cond.accountName = this.stpForm.accountName
              }

              this.$tango.sendMTIFunctionRequest(4989,'setPNLConfig',cond).then(rep => {
                this.$refs.spinner.hide()
                if (rep.resultCode === 0) {
                  this.$message({
                    message: 'Set config stp success',
                    type: 'success'
                  })
                  this.forceLoadingSTP = !this.forceLoadingSTP
                }
                else {
                  this.cancelSTP()
                  this.$message({
                    message: 'Error set config stp',
                    type: 'error'
                  })
                }
              }).catch(() => {
                this.$refs.spinner.hide()
              })
            }
          }
        })
      })
    },
    save () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
          if (valid) {

            const objectsEqual = (o1, o2) => 
            typeof o1 === 'object' && Object.keys(o1).length > 0 
                ? Object.keys(o1).length === Object.keys(o2).length 
                    && Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
                : o1 === o2;
            const arraysEqual = (a1, a2) => 
              a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]))

            let defaultList = this.makeDiff(this.defaultList, this.form.defaultList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.percentValue !== b2.percentValue || b1.bookSet !== b2.bookSet || b1.assetId !== b2.assetId)
            //let bookList = this.makeDiff(this.bookList, this.form.bookList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.groupList !== b2.groupList || b1.percentValue !== b2.percentValue)
            let [bookList,instrumentList] = this.makeDiffInstrumentList(this.bookList, this.form.bookList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.bookAccountNumber !== b2.bookAccountNumber || b1.entityId !== b2.entityId || b1.groupList !== b2.groupList || b1.percentValue !== b2.percentValue || b1.bookSet !== b2.bookSet || b1.assetId !== b2.assetId || !arraysEqual(b1.parameterList,b2.parameterList), (instrument1, instrument2) => instrument1.instrumentName === instrument2.instrumentName, (ins1, ins2) => ins1.percentValue !== ins2.percentValue)

            let coverageList = this.makeDiff(this.coverageList, this.form.coverageList.map(item => {
              return {
                groupName: item
              }
            }), (grp1, grp2) => grp1.groupName === grp2.groupName)
            if (defaultList.length || bookList.length || instrumentList.length || coverageList.length) {
              this.$refs.spinner.show()

              let cond = {
                parameterList: [
                  {
                    paramName: 'broker',
                    paramValue: this.activeName
                  }
                ],
                defaultList: defaultList,
                bookList: bookList,
                instrumentList: instrumentList,
                coverageList: coverageList
              }

              this.$tango.setBookConfig(cond).then(rep => {
                this.$refs.spinner.hide()
                if (rep.resultCode === 0) {
                  this.$message({
                    message: 'Set config book success',
                    type: 'success'
                  })
                  this.forceLoading = !this.forceLoading
                }
                else {
                  this.cancel()
                  this.$message({
                    message: 'Error set config',
                    type: 'error'
                  })
                }
              }).catch(() => {
                this.$refs.spinner.hide()
              })
            }
          }
        })
      })
    },
    // save () {
    //   let defaultList = this.makeDiff(this.defaultList, this.form.defaultList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.percentValue !== b2.percentValue)
    //   //let bookList = this.makeDiff(this.bookList, this.form.bookList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.groupList !== b2.groupList || b1.percentValue !== b2.percentValue)
    //   let [bookList,instrumentList] = this.makeDiffInstrumentList(this.bookList, this.form.bookList, (book1, book2) => book1.bookId === book2.bookId, (b1, b2) => b1.bookName !== b2.bookName || b1.bookAccountNumber !== b2.bookAccountNumber || b1.groupList !== b2.groupList || b1.percentValue !== b2.percentValue, (instrument1, instrument2) => instrument1.instrumentName === instrument2.instrumentName, (ins1, ins2) => ins1.percentValue !== ins2.percentValue)

    //   let coverageList = this.makeDiff(this.coverageList, this.form.coverageList.map(item => {
    //     return {
    //       groupName: item
    //     }
    //   }), (grp1, grp2) => grp1.groupName === grp2.groupName)
    //   if (defaultList.length || bookList.length || instrumentList.length || coverageList.length) {
    //     this.$refs.spinner.show()

    //     let cond = {
    //       parameterList: [
    //         {
    //           paramName: 'broker',
    //           paramValue: this.activeName
    //         }
    //       ],
    //       defaultList: defaultList,
    //       bookList: bookList,
    //       instrumentList: instrumentList,
    //       coverageList: coverageList
    //     }

    //     this.$tango.setBookConfig(cond).then(rep => {
    //       this.$refs.spinner.hide()
    //       if (rep.resultCode === 0) {
    //         this.$message({
    //           message: 'Set config book success',
    //           type: 'success'
    //         })
    //         this.forceLoading = !this.forceLoading
    //       }
    //       else {
    //         this.cancel()
    //         this.$message({
    //           message: 'Error set config',
    //           type: 'error'
    //         })
    //       }
    //     }).catch(err => {
    //       this.$refs.spinner.hide()
    //     })
    //   }
    // },
    validateTransfer(idx) {
    
      this.$nextTick().then(() => {
        this.$refs.transferForm[idx].validate(valid => {
          if (valid && this.activeName!==null && this.activeName!==undefined && this.transferAccountFilter!==null && this.transferAccountFilter!==undefined) {

            var clientInstrumentList = this.transferForm.instrumentList.filter(item => item.isUpdated === true)
            var instrumentList = this.makeDiffTransferInstrument(this.transferData.instrumentList, clientInstrumentList, (ins1, ins2) => ins1.instrumentName === ins2.instrumentName && ins1.orderSide === ins2.orderSide, (i1, i2) => parseFloat(i1.rate) !== parseFloat(i2.rate),['instrumentName','orderSide','rate'])

            let cond = {
              parameterList: [
                {
                  paramName: 'platform',
                  paramValue: this.activeName
                },
                {
                  paramName: 'accountNumber',
                  paramValue: this.transferAccountFilter
                },                
              ],
              bookId: this.transferForm.newBookId,
              percentValue: this.transferForm.newPercentValue
            }

            if (instrumentList.length) {
              cond.instrumentList = instrumentList
            }

            this.$refs.spinner.show()
            this.$tango.validateBookTransfer(cond).then(rep => {
              this.$refs.spinner.hide()
              if (rep.resultCode === 0) {
                this.$message({
                  message: 'Validate transfer success',
                  type: 'success'
                })
                this.shouldUpdateTransferHistory = true
                this.getCurrentAccountPosition()
              }
              else {
                this.cancelTransfer()
                this.$message({
                  message: 'Validate transfer error',
                  type: 'error'
                })
              }
            }).catch(() => {
              this.$refs.spinner.hide()
            })
          }
        })
      })
    },
    validateBook (rule, value, cb) {
      if (value !== '') {
        if (!/^defaultList/.test(rule.field)) {
          let arr = /^bookList\[([0-9]+)\]/.exec(rule.field)
          let me = -1
          if (arr) me = this.form.bookList[parseInt(arr[1])].bookId
          let idx = this.form.bookList.findIndex(b => b.bookName === value && b.bookId !== me)
          if (idx !== -1) {
            cb(new Error(this.$t('This bookName already exists')))
            return
          }
        }
      }
      cb()
    },
    validateAccPlatform (rule, value, cb) {
      if (value !== '') {
        if (!/^defaultList/.test(rule.field)) {
          let arr = /^bookList\[([0-9]+)\]/.exec(rule.field)
          let me = -1
          if (arr) me = this.form.bookList[parseInt(arr[1])].bookId
          let idx = this.form.bookList.findIndex(b => b.bookAccountNumber === value && b.bookId !== me)
          if (idx !== -1) {
            cb(new Error(this.$t('This acc platform already exists')))
            return
          }
        }
      }
      cb()
    },
    validatePercent (rule, value, cb) {
      /*
      if (!/^defaultList/.test(rule.field)) {
              let arr = /^bookList\[([0-9]+)\]/.exec(rule.field)
        let me = -1
        if (arr) {
          let val = this.form.bookList[parseInt(arr[1])].percentValue
          console.log(this.form.bookList[parseInt(arr[1])], val, Number.isNaN(val))
          if (Number.isNaN(val) || (val < 0) || (val > 100)) {
            cb(new Error(this.$t("Invalid percentage")))
          }
          cb()
        }
      }
      cb()
      */

      let val = Number.parseFloat(value)
      //console.log(value, val, Number.isNaN(val))
      if (Number.isNaN(val) || (val < 0) || (val > 100)) {
        cb(new Error(this.$t("Invalid percentage")))
      }
      cb()

    },
    validateTransferPercent (rule, value, cb) {
      /*
      if (!/^defaultList/.test(rule.field)) {
              let arr = /^bookList\[([0-9]+)\]/.exec(rule.field)
        let me = -1
        if (arr) {
          let val = this.form.bookList[parseInt(arr[1])].percentValue
          console.log(this.form.bookList[parseInt(arr[1])], val, Number.isNaN(val))
          if (Number.isNaN(val) || (val < 0) || (val > 100)) {
            cb(new Error(this.$t("Invalid percentage")))
          }
          cb()
        }
      }
      cb()
      */

      let val = Number.parseFloat(value)
      //console.log(value, val, Number.isNaN(val))
      if (Number.isNaN(val) || (val!==parseInt(value)) || (val < 0) || (val > 100)) {
        cb(new Error(this.$t("Invalid percentage")))
      }
      cb()

    },
    validateLPName (rule, value, cb) {
      if (value !== '') {
        let arr = /^accountsList\[([0-9]+)\]/.exec(rule.field)
        let me = -1
        if (arr) me = this.stpForm.accountsList[parseInt(arr[1])].id
        let idx = this.stpForm.accountsList.findIndex(a => a.accountName === value && a.id !== me)
        if (idx !== -1) {
          cb(new Error(this.$t('This name already exists')))
          return
        }
      }
      cb()
    },
    validateLPAcc (rule, value, cb) {
      if (value !== '') {
        let arr = /^accountsList\[([0-9]+)\]/.exec(rule.field)
        let me = -1
        if (arr) me = this.stpForm.accountsList[parseInt(arr[1])].id
        let idx = this.stpForm.accountsList.findIndex(a => a.accountNumber === value && a.id !== me)
        if (idx !== -1) {
          cb(new Error(this.$t('This acc already exists')))
          return
        }
      }
      cb()
    },
    cancelCreateBook () {
      this.newBook = false
      this.form.bookName = null
      this.form.percentValue = null
      this.form.bookSet = 0
      this.form.assetId = 0
      this.form.entityId = 0
    },
    createBook () {
      this.$nextTick().then(() => {
        this.$refs.form.validate(valid => {
        //this.$refs.form.validateField(['bookName','percentValue'],valid => {
          if (valid) {
            /*
            let bookId = 0
            this.bookList.forEach(book => {
              if (book.bookId > bookId) {
                bookId = book.bookId
              }
            })
            this.form.bookList.forEach(book => {
              if (book.bookId > bookId) {
                bookId = book.bookId
              }
            })
            bookId++
            */
            this.form.bookList.push({
              bookId: 0,
              bookName: this.form.bookName,
              groupList: this.form.groupList,
              percentValue: this.form.percentValue,
              bookSet: this.form.bookSet,
              assetId: this.form.assetId,
              entityId: this.form.entityId,
              showInstruments: false,
              addInstrumentName: "",
              addPercentValue: 0,
              instrumentList: [],
              showParameters: false
            })
            this.newBook = false
            this.form.bookName = null
            this.form.groupList = null
            this.form.percentValue = null
            this.form.bookSet = 0
            this.form.assetId = 0
            this.form.entityId = 0
          }
        })
      })
    },
    cancelCreateLP () {
      this.newLP = false
      this.stpForm.lpName = null
    },
    createLP (idx) {
      this.$nextTick().then(() => {
        this.$refs.stpForm[idx].validate(valid => {
          if (valid) {
            this.stpForm.accountsList.push({
              accountNumber: null,
              accountName: this.stpForm.lpName
            })
            this.newLP = false
            this.stpForm.lpName = null
          }
        })
      })
    },
    delLP (account) {
      let idx = this.stpForm.accountsList.findIndex(a => a.accountNumber === account.accountNumber)
      if (idx !== -1) this.stpForm.accountsList.splice(idx, 1)
    },
    delDefault (book) {
      let idx = this.form.defaultList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) this.form.defaultList.splice(idx, 1)
    },
    delBook (book) {
      let idx = this.form.bookList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) this.form.bookList.splice(idx, 1)
    },
    isDefault (book) {
      return this.form.defaultList.findIndex(b => b.bookId === book.bookId) !== -1
    },
    setDefault (book) {
      // this.form.defaultList.push(Object.assign({}, book))
      this.form.defaultList = [ Object.assign({}, book) ]
      this.form.defaultList[0].percentValue = 100
    },
    unsetDefault (book) {
      let idx = this.form.defaultList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) this.form.defaultList.splice(idx, 1)
    },
    onBookRename (book) {
      let idx = this.form.defaultList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) this.form.defaultList[idx].bookName = book.bookName
    },
    onAccPlatformRename (book) {
      let idx = this.form.defaultList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) this.form.defaultList[idx].bookAccountNumber = book.bookAccountNumber
    },
    clone: function (data) {
      if (Array.isArray(data)) {
        let ret = []
        for (let i = 0; i < data.length; i++) {
          this.$set(ret, i, this.clone(data[i]))
        }
        return ret
      }
      else if (typeof data === 'object') {
        let ret = {}
        for (let k in data) {
          this.$set(ret, k, this.clone(data[k]))
        }
        return ret
      }
      else return data
    },
    onShowInstruments(book) {
      let idx = this.form.bookList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) {
        this.form.bookList[idx].showInstruments = this.form.bookList[idx].showInstruments ? false : true
      }
    },
    onShowParameters(book) {
      let idx = this.form.bookList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) {
        this.form.bookList[idx].showParameters = this.form.bookList[idx].showParameters ? false : true
      }
    },
    addBookInstrument(book) {
      var instrument = {instrumentName : book.addInstrumentName, percentValue : book.addPercentValue }

      let idx = this.form.bookList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) {
        if (this.form.bookList[idx]!==null && this.form.bookList[idx]!==undefined && this.form.bookList[idx].hasOwnProperty('instrumentList')) {
          if (this.form.bookList[idx].instrumentList!=null && this.form.bookList[idx].instrumentList!=undefined) {
            let insIdx = this.form.bookList[idx].instrumentList.findIndex(i => i.instrumentName === instrument.instrumentName)
            if (insIdx === -1) {
              //insert
              this.form.bookList[idx].instrumentList.push(instrument)
            } else {
              //update
              if (this.form.bookList[idx].instrumentList[insIdx] !==null && this.form.bookList[idx].instrumentList[insIdx] !== undefined)
                this.form.bookList[idx].instrumentList[insIdx].percentValue = instrument.percentValue
            }
          }
        }
      }
    },
    deleteBookInstrument(book,instrument) {
      let idx = this.form.bookList.findIndex(b => b.bookId === book.bookId)
      if (idx !== -1) {
        if (this.form.bookList[idx]!==null && this.form.bookList[idx]!==undefined && this.form.bookList[idx].hasOwnProperty('instrumentList')) {
          if (this.form.bookList[idx].instrumentList!=null && this.form.bookList[idx].instrumentList!=undefined) {
            let insIdx = this.form.bookList[idx].instrumentList.findIndex(i => i.instrumentName === instrument.instrumentName)
            if (insIdx !== -1) this.form.bookList[idx].instrumentList.splice(insIdx, 1)
          }
        }
      }
    },
    getSideLabel(side) {
      if (side === 'B')
        return 'Buy'
      else if (side === 'S')
        return 'Sell'
      return ''
    },
    getInstrumentPrecision(instrument) {
      if (instrument.decimals !==null && instrument.decimals !==undefined)
        return instrument.decimals
      return 0
    },
    getPrecisionStep(precision) {
      if (precision && precision > 0)
        return Math.pow(10,-precision)
      return 1
    },
    changeTransferInstrumentRate(instrument) {
      let idx = this.transferForm.instrumentList.findIndex(ins => ins.instrumentName === instrument.instrumentName && ins.orderSide === instrument.orderSide )
      if (idx !== -1)
        this.transferForm.instrumentList[idx].isUpdated = true
    },
    resetTransferFormFields() {
      let idx = this.brokerListSelect.findIndex(item => item.label === this.activeName)
      if (idx !== -1) {
        if (this.$refs.transferForm && this.$refs.transferForm[idx])
          this.$refs.transferForm[idx].clearValidate()
        if (this.$refs.newBookIdFormItem && this.$refs.newBookIdFormItem[idx])
        this.$refs.newBookIdFormItem[idx].validateDisabled = true
      }
    },
    getCurrentAccountPosition() {
        let cond = {
          parameterList: [{
            paramName: 'platform',
            paramValue: this.activeName
          },
          {
            paramName: 'accountNumber',
            paramValue: this.transferAccountFilter
          }]
        }

        return this.$tango.getAccountPosition(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Transfer Config')
          } else {

            this.transferData = {
              brokerName: rep.brokerName,
              bookId: rep.bookId,
              bookName: rep.bookName,
              percentValue: rep.percentValue,
              dosId: rep.dosId,
              dosName: rep.dosName,
              instrumentList: [],
              newBookId: null,
              newPercentValue: 100
            }

            if (rep.instrumentList && rep.instrumentList.length) {
              this.transferData.instrumentList = rep.instrumentList
            }

            this.resetTransferFormFields()

            this.transferForm.brokerName = this.transferData.brokerName
            this.transferForm.bookId = this.transferData.bookId
            this.transferForm.bookName = this.transferData.bookName
            this.transferForm.percentValue = this.transferData.percentValue
            this.transferForm.dosId = this.transferData.dosId
            this.transferForm.dosName = this.transferData.dosName
            this.transferForm.instrumentList = this.clone(this.transferData.instrumentList)
            this.transferForm.newBookId = this.transferData.newBookId
            this.transferForm.newPercentValue = this.transferData.newPercentValue
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
    },
    transferAccountRemoteMethod(query='') {
      this.transferAccountQuery = query
      this.transferAccountLoading = true
    },
    onVisibleChangeTransferAccountFilter(value) {
      if (!value)
        this.transferAccountRemoteMethod()
    }
  },
  computed: {
    ...mapGetters([ 'brokerList', 'instrumentList', 'accountList', 'bookSetList', 'bookAssetList' ]),
    ...mapState({ bookConfigMode: state => state.settingsMonitor.settingParams.bookConfigMode }),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    groupSearchList () {
      if (!this.form.searchGroupName) return this.groupList
      return this.groupList.filter(item => item.groupName.toLowerCase().includes(this.form.searchGroupName.toLowerCase()))
    },
    singleBookSetList () {
      if (this.bookSetList) {
        return this.bookSetList.filter(item => item.bookSet!==0)
      }
      return []
    },
    // bookListSelect () {
    //   if (this.transferForm.bookId===null || this.transferForm.bookId===undefined ||this.transferForm.bookId==='') return this.bookList
    //   return this.bookList.filter(item => item.bookId !== this.transferForm.bookId)
    // },
    // brokerListSelect: {
    //   get: function () {
    //     this.brokerList.forEach(b2 => {
    //       b2.brokerList.forEach(b => {
    //         if (b.status === 1 && this.$acl.isAllowedBroker(b.label)) {
    //           this.localBrokerList.push({
    //             functionId: b.functionId,
    //             label: b.label,
    //             isAllowed: false
    //           })
    //         }
    //       })
    //     })
    //     return this.localBrokerList
    //   },
    //   set: function (force) {
    //     this.localBrokerList.forEach(b => b.isAllowed = force)
    //   }
    // },
    brokerListSelect () {
      let localBrokerList = []
      this.brokerList.forEach(b2 => {
        b2.brokerList.forEach(b => {
          if (b.status === 1 && this.$acl.isAllowedBroker(b.label)) {
            localBrokerList.push({
              functionId: b.functionId,
              label: b.label,
              isAllowed: false
            })
          }
        })
      })
      return localBrokerList
    },
    currentInstrumentList() {
      if (this.instrumentList && this.instrumentList.hasOwnProperty(this.activeName))
        return this.instrumentList[this.activeName]
      return []
    },
    currentAccountList() {
      if (this.accountList && this.accountList.hasOwnProperty(this.activeName))
        return this.accountList[this.activeName]
      return []
    }
  },
  asyncComputed: {
    bookConfig: {
      get () {
        if (!this.activeName) return {}
        this.forceLoading = !this.forceLoading
        let cond = {
          functionId: 'getBookConfig',
          parameterList: [{
            paramName: 'broker',
            paramValue: this.activeName
          }]
        }
        return this.$tango.getBookConfig(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Book Config')
          } else {
            if (rep.bookList && rep.bookList.length) {

              for (var i = 0; i < rep.bookList.length; i++) {
                rep.bookList[i].showInstruments = false
                rep.bookList[i].addInstrumentName = ""
                rep.bookList[i].addPercentValue = 0
                rep.bookList[i].showParameters = false

                if (!rep.bookList[i].hasOwnProperty("instrumentList"))
                  rep.bookList[i].instrumentList = []
              }

              this.bookList = rep.bookList
              this.form.bookList = this.clone(rep.bookList)
            }
            if (rep.defaultList && rep.defaultList.length) {
              this.defaultList = rep.defaultList
              this.form.defaultList = this.clone(rep.defaultList)
            }
            if (rep.coverageList && rep.coverageList.length) {
              this.coverageList = rep.coverageList
              this.form.coverageList = rep.coverageList.map(item => item.groupName)
            }
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: {}
    },
    stpConfig: {
      get () {
        if (!this.activeName) return {}
        this.forceLoadingSTP = !this.forceLoadingSTP
        let cond = {
          functionId: 'getPNLConfig',
          parameterList: [{
            paramName: 'broker',
            paramValue: this.activeName
          }]
        }
        return this.$tango.sendMTIRequest(4989,cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : STP Config')
          } else {
            if (rep.accountsList && rep.accountsList.length) {
              this.accountsList = rep.accountsList
              this.stpForm.accountsList = this.clone(rep.accountsList)
              this.stpData.accountsList = rep.accountsList
            } else {
              this.stpForm.accountsList = []
              this.stpData.accountsList = []
            }

            this.stpForm.accountName = rep.accountName
            this.stpForm.groupName = rep.groupName

            this.stpData.accountName = rep.accountName
            this.stpData.groupName = rep.groupName
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: {}
    },
    groupList: {
      get () {
        if (!this.activeName) return []
        let cond = {
          functionId: 'getGroupList',
          parameterList: [{
            paramName: 'broker',
            paramValue: this.activeName
          }]
        }
        return this.$tango.getBookConfig(cond).then(rep => {
          this.fullscreenLoading = false
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Book Config')
          } else {
            if (rep.groupList && rep.groupList.length) {
              return rep.groupList
            }
          }
          return []
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: []
    },
    transferAccountSearch:
    {
      get () {
        var results = []
        if (this.transferAccountQuery!=='') {
          results = this.currentAccountList.filter(account => 
          account.dosId.toString().toLowerCase().includes(this.transferAccountQuery.toLowerCase()) || 
          account.dosName.toLowerCase().includes(this.transferAccountQuery.toLowerCase()))
        }
        else {
          results = this.currentAccountList
        }

        if (Number.isInteger(this.transferAccountLimit) && this.transferAccountLimit>0)
          results = results.slice(0,this.transferAccountLimit)

        this.transferAccountList = results
        this.transferAccountQuery = ""
        this.transferAccountLoading = false
      },
      default: {},
      shouldUpdate () {
        return (this.activeName !== undefined && this.activeName !== null && this.transferAccountLoading)
      }
    },
    accountPlatformConfig: 
    {
      get () {
        this.getCurrentAccountPosition()
      },
      default: {},
      shouldUpdate () {
        return (this.activeName !== undefined && this.activeName !== null && this.transferAccountFilter !== undefined && this.transferAccountFilter!== null)
      }
    },
    transferHistoryConfig: {
      get () {
        let cond = {
          parameterList: [{
            paramName: 'platform',
            paramValue: this.activeName
          }]
        }

        return this.$tango.getBookTransferList(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Transfer History Config')
          } else {
            if (rep.dossierList && rep.dossierList.length) {
              this.bookTransferList = rep.dossierList
            }

            //adjust bus
            for (let i = 0; i < this.bookTransferList.length; i++) {
              if (this.bookTransferList[i].bookList!==null && this.bookTransferList[i].bookList!==undefined) {
                for (let b = 0; b < this.bookTransferList[i].bookList.length; b++) {
                  if (b===0) {
                    this.bookTransferList[i].fromBookName = this.bookTransferList[i].bookList[b].bookName
                    this.bookTransferList[i].fromPercentValue = this.bookTransferList[i].bookList[b].percentValue
                  } else {
                    this.bookTransferList[i].toBookName = this.bookTransferList[i].bookList[b].bookName
                    this.bookTransferList[i].toPercentValue = this.bookTransferList[i].bookList[b].percentValue
                  }
                }
              }
            }

            this.shouldUpdateTransferHistory = false
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })


      },
      default: {},
      shouldUpdate () {
        return (this.activeName !== undefined && this.activeName !== null && this.activeTab === 'transferHistory' && this.shouldUpdateTransferHistory)
      }
    },
    entityList: {
      get () {
        return this.$tango.getEntityList().then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error('ERROR : Entity List')
          } else {
            if (rep.entityList && rep.entityList.length) {
              return rep.entityList
            }
          }
          return []
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      default: []
    }
  }
}
</script>

<style lang='scss'>

.inputauto {
  .el-input, .el-input__inner {
    width: 100% !important;
  }
}

.select-container {
  border: solid 1px rgb(112, 110, 110);
  padding: 5px;
  border-radius: 5px;

  .inDiv {
    padding: 10px;
    // border-bottom: solid 1px #FFF;
  }
}

.bookTabs.el-tabs--left {
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
}
.bookTabs .subTabs.el-tabs--top {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

.bookTabs.el-tabs--left .el-tabs__item.is-left {
  border: solid 1px transparent !important;
}
.bookTabs.el-tabs--left .el-tabs__content {
  /* background: black; */
  padding-left: 10px;
  flex: 1 1 auto;
}
.bookTabs .subTabs.el-tabs--top .el-tabs__content {
  padding: 10px;
}
.bookTabs.el-tabs--left .el-tabs__header.is-left {
  margin-right: 0px;
  border-right: solid 1px transparent !important;
}
.bookTabs .el-tab-pane {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 100%;
}
.groupTable th, .bookTable th, .groupTable td, .bookTable td {
  padding: 10px 5px;
}

.groupTable .colTitle,
.bookTable .colTitle {
  font-size: 1.2em;
}

.config-container {
  padding: 20px 10px;
  // margin: 20px 0;
  border-radius: 5px;
}


.loadingClass {
  font-size: 2em;
  color: red !important;
}

.el-transfer {
  display: flex;
  flex: 1 1 auto;

  .el-transfer-panel  {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    max-width: 350px;

    .el-checkbox__label {
      padding-left: 18px !important;
    }

    .el-transfer-panel__body
    {
      height: unset;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
    }

    .el-transfer-panel__filter {
      display: inline-flex;
      width: unset;
      min-height: 32px;
    }

    .el-transfer-panel__list {
      height: 0px;
      flex: 1 1 auto;

      label {
        margin-right: 50%;
      }
    }
  }

  .el-transfer__buttons {
    align-self: center;
    .el-button.el-button--base {
      padding: 10px !important;
      margin: 5px;
    }
    .el-button--primary {
      &.is-disabled,
      &.is-disabled:hover,
      &.is-disabled:focus,
      &.is-disabled:active {
        border: unset !important;
      }
    }
  }
}

.title {
  font-size: 1.3em;
  padding: 10px 0;
}

.tab-container {
  .el-form-item {
    width: 300px;
  }
}

</style>

